<template>
  <div>
    <span v-html="env" />

    Is userLogged : {{ isUserLogged }}
    <br />
    Is userPremium : {{ userSubscription }}
  </div>
</template>

<script>
import userMixin from '@/mixins/user'

export default {
  name: 'Debug',
  mixins: [userMixin],
  computed: {
    env() {
      return Object.keys(process.env).map(key => `${key} : ${process.env[key]}<br />`)
    }
  },
  created() {
    if (localStorage.getItem('production_debug') || process.env.VUE_APP_ENV === 'development') {
      this.showDebug = true
    } else {
      this.$router.back()
    }
  }
}
</script>